module.exports = __webpack_public_path__ + "img/temb10.84786b82.jpg";